import { render, staticRenderFns } from "./Gantogram.vue?vue&type=template&id=1d8675b5&scoped=true&"
import script from "./Gantogram.vue?vue&type=script&lang=js&"
export * from "./Gantogram.vue?vue&type=script&lang=js&"
import style0 from "./Gantogram.vue?vue&type=style&index=0&id=1d8675b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8675b5",
  null
  
)

export default component.exports